import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button, Link } from 'base-ui'

import { useExperimentalAddStaticFileHost } from '../../../../../experiments/new-cdn-experiment/useExperimentalAddStaticFileHost'
import { useGlobalConfigContext } from '../../../../../global-config'
import { StaticImage } from '../../../../../image'
import {
  urlResolverGetFreeEnvelopePdf,
  urlResolverGetRedeemEprescription,
  urlResolverGetRedeemPaperPrescription,
} from '../../../../../url-handling'
import { erxBonusLandingPageTextBreak } from '../../../../components/ErxBonusLandingPageTranslationValues'
import ImgNfcCard from '../../../../images/ImgNfcCard.png'
import ImgPKVRezeptBlau from '../../../../images/ImgPKVRezeptBlau.png'

export const ErxBonusLandingPageTypesOfPrescriptionsCardsV1: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()

  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  const linkRedeemPaperPrescription = (text: ReactNode[]): ReactElement => (
    <Link
      href={addStaticCdnHostToUrl(urlResolverGetFreeEnvelopePdf())}
      rel="noreferrer noopener"
      target="_blank"
    >
      {text}
    </Link>
  )

  const values = {
    break: erxBonusLandingPageTextBreak,
  }

  return (
    <div className="flex flex-col justify-between gap-6 pt-6 tablet:flex-row">
      <div className="flex flex-1 flex-col gap-6 rounded-2xl border border-dark-primary-min p-6">
        <div className="flex flex-col items-start gap-6 tablet:flex-row">
          <StaticImage
            alt={intl.formatMessage({
              id: 'deErx.bonus.typesOfPrescriptions.normalPrescription.title',
            })}
            className="max-w-max object-contain"
            height={120}
            src={ImgNfcCard}
            width={173}
          />

          <div className="flex flex-col gap-4">
            <p className="text-m font-medium">
              <FormattedMessage id="deErx.bonus.typesOfPrescriptions.normalPrescription.title" />
            </p>
            <p>
              <FormattedMessage
                id="deErx.bonus.typesOfPrescriptions.normalPrescription.description"
                values={values}
              />
            </p>
          </div>
        </div>
        <Button<'a'>
          className="w-full"
          color="secondary"
          href={urlResolverGetRedeemEprescription(globalConfig)}
          size="medium"
          slots={{ root: 'a' }}
        >
          <FormattedMessage id="deErx.bonus.typesOfPrescriptions.normalPrescription.btn" />
        </Button>
      </div>

      <div className="flex flex-1 flex-col gap-6 rounded-2xl border border-dark-primary-min p-6">
        <div className="flex flex-col items-start gap-6 tablet:flex-row">
          <StaticImage
            alt={intl.formatMessage({
              id: 'deErx.bonus.typesOfPrescriptions.privatePrescription.title',
            })}
            className="max-w-max"
            height={120}
            src={ImgPKVRezeptBlau}
            width={173}
          />

          <div className="flex flex-col gap-4">
            <p className="text-m font-medium">
              <FormattedMessage id="deErx.bonus.typesOfPrescriptions.privatePrescription.title" />
            </p>
            <p>
              <FormattedMessage
                id="deErx.bonus.typesOfPrescriptions.privatePrescription.description"
                values={{
                  link: linkRedeemPaperPrescription,
                }}
              />
            </p>
          </div>
        </div>
        <Button<'a'>
          className="w-full text-wrap"
          color="secondary"
          href={urlResolverGetRedeemPaperPrescription(globalConfig)}
          size="medium"
          slots={{ root: 'a' }}
        >
          <FormattedMessage id="deErx.bonus.typesOfPrescriptions.privatePrescription.btn" />
        </Button>
      </div>
    </div>
  )
}
